var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-app', {
    ref: "document",
    attrs: {
      "id": "inspire"
    }
  }, [_c('notification'), _c(_vm.layout, {
    tag: "component"
  }), _c('versionupdate')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }